// src/components/common/AdminListItem.js
import React from "react";

/**
 * Simple list item used by admin tabs
 * - title: string
 * - subtitle: string (optional)
 * - onClick: func
 * - active: bool
 */
export default function AdminListItem({ title, subtitle, onClick, active }) {
  return (
    <li
      onClick={onClick}
      style={{
        padding: "0.6rem",
        borderBottom: "1px solid #f1f5f9",
        cursor: "pointer",
        background: active ? "#f8fafc" : "transparent",
        fontSize: "1rem" /* gunakan rem di root */,
      }}
    >
      <div style={{ fontWeight: 600 }}>{title}</div>
      {subtitle ? (
        <div style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "0.25rem" }}>
          {subtitle}
        </div>
      ) : null}
    </li>
  );
}
